const styles = {
  link: { textDecoration: "none", fontWeight: 600, color: "#2a61dd" },
};

export default styles;
